<template>
  <div class="a-login-view flex items-center">
    <div class="login-row">
      <div class="info-card-wrap">
        <q-card color="white" text-color="black">
          <q-card-title class="q-pa-lg">
            <div class="q-title q-mb-sm">Autohaus Manager</div>
          </q-card-title>
          <div class="row items-stretch flex-1">
            <div class="col-6 promo-section q-pa-md">
              <div class="column no-wrap gutter-y-md">
                <div class="q-mb-md">
                  <img :src="alzuraCosmos" alt="Alzura Cosmos">
                </div>

                <div class="row q-mt-md">
                  <q-chip color="primary" round class="feature-chip">
                    Fahrzeugverwaltung
                  </q-chip>
                  <q-chip color="primary" text-color="white" class="feature-chip">
                    Inseratsmanagement
                  </q-chip>
                  <q-chip color="primary" text-color="white" class="feature-chip">
                    Anfragenverwaltung
                  </q-chip>
                  <q-chip color="primary" text-color="white" class="feature-chip">
                    Kundenverwaltung
                  </q-chip>
                  <q-chip color="primary" text-color="white" class="feature-chip">
                    Dokumentenmanagement
                  </q-chip>
                  <q-chip color="primary" text-color="white" class="feature-chip">
                    E-Mail Anbindung, Multi-User uvm. ...
                  </q-chip>
                </div>
              </div>
            </div>

            <div class="col-6 news-section relative-position column no-wrap overflow-hidden">
              <div class="col relative-position">
                <q-scroll-area class="absolute-full">
                  <q-list no-border separator dense class="q-mt-sm q-pt-lg">
                    <q-item
                      v-for="item in latestUpdates"
                      :key="item.ID"
                      multiline
                      dense
                    >
                      <q-item-side :icon="item.icon || 'update'" color="faded q-mt-sm" />
                      <q-item-main>
                        <q-item-tile label class="q-body-1 q-mt-sm">
                          <span class="float-right text-faded q-caption">{{ (item.displayDate || item.created) | formatMonthYear }}</span>
                          {{ item.title }}
                        </q-item-tile>
                        <q-item-tile
                          label
                          class="text-faded q-mt-sm q-caption"
                          :lines="item.expanded ? 0 : 2"
                        >
                          {{ item.snippet }}
                        </q-item-tile>
                        <div
                          class="text-faded cursor-pointer  q-caption"
                          @click="item.expanded = !item.expanded"
                        >
                          {{ item.expanded ? 'Weniger' : 'Mehr' }}
                          <q-icon :name="item.expanded ? 'expand_less' : 'expand_more'" />
                        </div>
                      </q-item-main>
                    </q-item>
                  </q-list>
                </q-scroll-area>
              </div>

              <q-chip
                color="primary"
                text-color="white"
                square
                dense
                class="absolute-top-left no-margin"
              >
                NEWS
              </q-chip>
            </div>
          </div>
        </q-card>
      </div>
      <div class="login-card-wrap">
        <q-card color="white" text-color="black">
          <q-card-title class="q-pa-lg">
            <div class="column">
              <div class="q-title q-mb-sm">Autohaus Manager</div>
              <div class="q-body-1 flex items-center q-pl-xl">
                part of <img src="@/assets/AlzuraEBusinessLogo.png" width="300">
              </div>
              <div class="q-body-1 q-my-lg">
                Cloudbasierte DMS für kleine und mittelständische Unternehmen
              </div>
              <div class="q-body-1 q-my-lg text-center">
                Melden Sie sich mit Ihrem ALZURA Konto an,<br>um auf alle Funktionen zuzugreifen
              </div>
            </div>
          </q-card-title>
          <q-card-main>
            <div class="column no-wrap relative-position gutter-y-sm">
              <q-alert type="negative" v-if="error">{{ error }}</q-alert>

              <q-field class="q-mt-lg">
                <AlzuraOAuthButton :loading="checkingSso" />
              </q-field>

              <AlzuraOAuthRegister />
            </div>
          </q-card-main>
        </q-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AlzuraOAuthRegister from '@/components/base/AlzuraOAuthRegister.vue';
import AlzuraOAuthButton from '@/components/base/AlzuraOAuthButton.vue';
import alzuraCosmos from '@/assets/AlzuraCosmos.png';

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'LoginView',
  components: {
    AlzuraOAuthRegister,
    AlzuraOAuthButton,
  },
  data() {
    return {
      alzuraCosmos,
      latestUpdates: [],
      checkingSso: true,
    };
  },
  computed: {
    ...mapState('auth', ['error']),
  },
  async created() {
    const { query } = this.$route;

    this.loadLatestUpdates();

    if (this.$store.getters['auth/loggedIn']) {
      this.$router.push(query.next || '/');
      return;
    }

    try {
      const hasSSOCookie = await this.checkSSOCookie();

      if (hasSSOCookie) {
        this.$router.push({
          path: '/oauth/result',
          query: query.next ? { next: query.next } : undefined,
        });
        return;
      }
    } finally {
      this.checkingSso = false;
    }
  },

  methods: {
    async checkSSOCookie() {
      const base = import.meta.env.PROD ? 'https://autengo.alzura.com' : '';
      const { data } = await this.$axios.get(`${base}/v2/auth/alzura/sso`, { withCredentials: true });
      return data;
    },

    async loadLatestUpdates() {
      try {
        const { data } = await this.$axios.get('/v2/notifications/latest-updates');
        this.latestUpdates = data.data.map(n => ({ ...n, expanded: false }));
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import theme

.a-login-view {
  background-image: linear-gradient(to top, white, transparent), url('@/assets/autengo-login-bg.jpeg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: stretch;
  gap: 32px;
  width: 100%;
  max-width: 1800px;
  box-sizing: border-box;
  padding: 24px 16px;
}

.info-card-wrap {
  flex: 1 1 840px;
  max-width: 940px;
  min-width: 0;
}

.login-card-wrap {
  flex: 0 1 480px;
  min-width: 0;
}

.promo-section {
  background-color: #e5e5e540;
}

.news-section {
  background-color: #eef0ff;
}

.login-row >>> .q-card {
  min-height: 500px;
  display: flex;
  flex-direction: column;
}

.feature-chip {
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 8px 12px;
  border-radius: 2rem
}

@media (max-width: 1199px) {
  .info-card-wrap {
    display: none;
  }

  .login-row {
    padding: 16px;
  }
}
</style>
